/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiDialogContentStyle = (): Components<Theme>["MuiDialogContent"] => ({
  styleOverrides: {
    root: {
      padding: 0,
    },
  },
});
